export const PERMISSIONS = {
  SL_RECEIVEPAY_VIEW: 'SL_RECEIVEPAY_VIEW',
  SL_RECEIVEPAY_EXPORT: 'SL_RECEIVEPAY_EXPORT',
};
